import { Box, Typography } from '@mui/material';
import { userCardStyles, UserTermCardActions, UserTermCardStatus } from '.';
import { IUserTerms } from 'types/api_permission_responses';
import { formatDateToDisplay, normalizeIso } from 'utils/date_utils';

interface UserTermCardProps {
  termData: IUserTerms;
  onEdit: (id: string) => void;
  onApprove: (id: string) => void;
}

const UserTermCard: React.FC<UserTermCardProps> = ({
  termData,
  onEdit,
  onApprove,
}) => {



  const endDateText =
    termData.endDateIndefinite || !termData.endDate
      ? 'Indeterminada'
      : formatDateToDisplay(normalizeIso(termData.endDate));


  console.log('termData', termData);
  return (
    <Box sx={{ ...userCardStyles.container, position: 'relative' }}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          marginTop: '10px',
          width: '100%',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            flexWrap: 'nowrap',
            alignContent: 'flex-start',
            alignItems: 'flex-start',
            width: '100%',
          }}
        >
          {/* APENAS COMENTEI CASO QUEIRAM VER O ID DO TERMO NOVAMENTE SÓ DESCOMENTAR */}
          {/* <Typography
            sx={{
              color: '#000000DE',
              fontWeight: 500,
              fontSize: '18px',
              lineHeight: '28.26px',
              letterSpacing: '0.1px',
              paddingLeft: '16px',
            }}
          >

          </Typography> */}
          <Typography
            sx={{
              color: '#00000099',
              fontWeight: 400,
              fontSize: '16px',
              lineHeight: '26.56px',
              letterSpacing: '0.4px',
              paddingLeft: '16px',
            }}
          >
            {`ID da Vigência: ${termData.id}`}
          </Typography>
          <Typography
            sx={{
              color: '#00000099',
              fontWeight: 400,
              fontSize: '16px',
              lineHeight: '26.56px',
              letterSpacing: '0.4px',
              paddingLeft: '16px',
            }}
          >
            {`Data inicial: ${formatDateToDisplay(
              termData.startDate.toString(),
            )}`}
          </Typography>
          <Typography
            sx={{
              color: '#00000099',
              fontWeight: 400,
              fontSize: '16px',
              lineHeight: '26.56px',
              letterSpacing: '0.4px',
              paddingLeft: '16px',
            }}
          >
            {`Data final: ${endDateText}`}
          </Typography>
          <Typography
            sx={{
              color: '#00000099',
              fontWeight: 400,
              fontSize: '16px',
              lineHeight: '26.56px',
              letterSpacing: '0.4px',
              paddingLeft: '16px',
            }}
          >
            {`Data final indeterminada: ${termData.endDateIndefinite ? 'Sim' : 'Não'
              }`}
          </Typography>

          {/* TODO: integrar com backend para exibir documento de vigencia anexo */}
          {/* <Typography
            sx={{
              color: '#00000099',
              fontWeight: 400,
              fontSize: '16px',
              lineHeight: '26.56px',
              letterSpacing: '0.4px',
              paddingLeft: '16px',
              marginBottom: '10px',
            }}
          >
            {`Documento anexo: (ADICIONAR DOCUMENTO AQUI)`}
          </Typography> */}
          <Box sx={{ width: '100%' }}>
            <UserTermCardStatus status={termData.status} />
          </Box>
        </Box>
        <Box
          sx={{
            position: 'absolute',
            top: '8px',
            right: '16px',
          }}
        >
          <UserTermCardActions
            idTerm={termData.id}
            onEdit={onEdit}
            onApprove={onApprove}
            vigenciaStatus={termData.status}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default UserTermCard;
